// Icons the public website (landing pages, sign-in, dark modals) can use: part of every page's first download.
// Generated from a scan of the code the public routes reach; anything else lives in platformIcons.ts.
import type { IconComponent } from "./iconRegistry"
import { ReactComponent as Emergency } from "./images/alert-urgent.svg"
import { ReactComponent as Aoi } from "./images/aoi.svg"
import { ReactComponent as Approvals } from "./images/approvals.svg"
import { ReactComponent as Archive } from "./images/archive.svg"
import { ReactComponent as ArrowBack } from "./images/arrow-back.svg"
import { ReactComponent as ArrowLeft } from "./images/arrow-left.svg"
import { ReactComponent as ArrowRight } from "./images/arrow-right.svg"
import { ReactComponent as ArrowScrollUp } from "./images/arrow-scroll-up.svg"
import { ReactComponent as At } from "./images/at.svg"
import { ReactComponent as WhatsAppNew } from "./images/baseline-whatsapp.svg"
import { ReactComponent as Bin } from "./images/bin.svg"
import { ReactComponent as BlueTick } from "./images/blue-tick.svg"
import { ReactComponent as ButtonMinus } from "./images/button-minus.svg"
import { ReactComponent as ButtonPlus } from "./images/button-plus.svg"
import { ReactComponent as CalendarAll } from "./images/calendar-all.svg"
import { ReactComponent as Calendar } from "./images/calendar-date-picker.svg"
import { ReactComponent as Camera } from "./images/camera.svg"
import { ReactComponent as Image } from "./images/card-image.svg"
import { ReactComponent as Details } from "./images/card-list.svg"
import { ReactComponent as Checked } from "./images/checked.svg"
import { ReactComponent as CircledTick } from "./images/circled-tick.svg"
import { ReactComponent as ClientCentric } from "./images/client-centric.svg"
import { ReactComponent as Clip } from "./images/clip.svg"
import { ReactComponent as Clock } from "./images/clock.svg"
import { ReactComponent as Close } from "./images/close-modal-2.svg"
import { ReactComponent as CloseModal } from "./images/close-modal.svg"
import { ReactComponent as CloseNotification } from "./images/close-notification.svg"
import { ReactComponent as CollapseMode } from "./images/collapse-mode.svg"
import { ReactComponent as CopyFile } from "./images/copy-file.svg"
import { ReactComponent as DocFile } from "./images/doc-icon.svg"
import { ReactComponent as Documents } from "./images/documents.svg"
import { ReactComponent as DocxIcon } from "./images/docx.svg"
import { ReactComponent as DoubleGrayDots } from "./images/double-gray-dots.svg"
import { ReactComponent as DownArrow } from "./images/down-arrow.svg"
import { ReactComponent as Download } from "./images/download.svg"
import { ReactComponent as Easetech } from "./images/ease-tech-company-name-white.svg"
import { ReactComponent as LogoDarkBlueFlipped } from "./images/easetech-logo-flipped.svg"
import { ReactComponent as Logo } from "./images/easetech-logo.svg"
import { ReactComponent as Emails } from "./images/emails.svg"
import { ReactComponent as EnvelopeUpload } from "./images/envelope-upload.svg"
import { ReactComponent as EnvelopWithLock } from "./images/envelope-with-lock.svg"
import { ReactComponent as Envelop } from "./images/envelope.svg"
import { ReactComponent as ExcelLogo } from "./images/excel-logo.svg"
import { ReactComponent as ExclamationSquare } from "./images/exclamation-square.svg"
import { ReactComponent as ExclamationTriangle } from "./images/exclamation-triangle.svg"
import { ReactComponent as Exclamation } from "./images/exclamation.svg"
import { ReactComponent as ExpandArrowDown } from "./images/expand-arrow-down.svg"
import { ReactComponent as ExpandArrowUp } from "./images/expand-arrow-up.svg"
import { ReactComponent as ExpandMode } from "./images/expand-mode.svg"
import { ReactComponent as Eye } from "./images/eye.svg"
import { ReactComponent as FilePlay } from "./images/file-play.svg"
import { ReactComponent as Free } from "./images/free.svg"
import { ReactComponent as GreenTickInCircle } from "./images/green-tick-in-circle.svg"
import { ReactComponent as GreenTick } from "./images/green-ticked.svg"
import { ReactComponent as Headphones } from "./images/headphones.svg"
import { ReactComponent as InfoCircle } from "./images/info-circle.svg"
import { ReactComponent as JsonIcon } from "./images/json.svg"
import { ReactComponent as KmlIcon } from "./images/kml.svg"
import { ReactComponent as LampIdea } from "./images/lamp-idea.svg"
import { ReactComponent as License } from "./images/license.svg"
import { ReactComponent as LittleCross } from "./images/little-cross.svg"
import { ReactComponent as LogoEasetechWhite } from "./images/logo_company_name_white.svg"
import { ReactComponent as LongRightArrow } from "./images/long-right-arrow.svg"
import { ReactComponent as MagnifyingGlassGray } from "./images/magnifying-glass-gray.svg"
import { ReactComponent as MagnifyingGlass } from "./images/magnifying-glass.svg"
import { ReactComponent as ManagerMap } from "./images/map-manager.svg"
import { ReactComponent as MapPinnedGeometry } from "./images/map-pinned-geometry.svg"
import { ReactComponent as Minimize } from "./images/minimize.svg"
import { ReactComponent as MoneyCircle } from "./images/money-circle.svg"
import { ReactComponent as OrangeCircles } from "./images/orange-circles.svg"
import { ReactComponent as PdfDocIcon } from "./images/pdf-doc-icon.svg"
import { ReactComponent as Phone } from "./images/phone.svg"
import { ReactComponent as PhotoCamera } from "./images/photocamera.svg"
import { ReactComponent as Profile } from "./images/profile-line.svg"
import { ReactComponent as ProjectInfo } from "./images/project-info.svg"
import { ReactComponent as Refresh } from "./images/refresh.svg"
import { ReactComponent as RequestInfo } from "./images/request-info-2.svg"
import { ReactComponent as RotateOrbit } from "./images/rotate-orbit.svg"
import { ReactComponent as Save } from "./images/save.svg"
import { ReactComponent as Settings } from "./images/settings.svg"
import { ReactComponent as SliderSettings } from "./images/sliders-settings.svg"
import { ReactComponent as SmallWhiteTick } from "./images/small-white-tick.svg"
import { ReactComponent as SquareLinks } from "./images/square-links.svg"
import { ReactComponent as StarredAward } from "./images/starred-award.svg"
import { ReactComponent as Table } from "./images/table.svg"
import { ReactComponent as Telegram } from "./images/telegram.svg"
import { ReactComponent as ThumbUp } from "./images/thumb-up.svg"
import { ReactComponent as Tick } from "./images/tick.svg"
import { ReactComponent as TiffIcon } from "./images/tiff.svg"
import { ReactComponent as Timer } from "./images/timer.svg"
import { ReactComponent as UploadColored } from "./images/upload-in-color.svg"
import { ReactComponent as AppCreateUpload } from "./images/upload.svg"
import { ReactComponent as User } from "./images/user.svg"
import { ReactComponent as Users } from "./images/users.svg"
import { ReactComponent as WarningCircle } from "./images/warning-circle.svg"
import { ReactComponent as Whatsapp } from "./images/whatsapp.svg"
import { ReactComponent as Zipfile } from "./images/zip-file-icon.svg"
import { ReactComponent as BurgerIcon } from "./website-icons/burger-button.svg"
import { ReactComponent as CallCenter } from "./website-icons/call-center.svg"
import { ReactComponent as CellHouse } from "./website-icons/cell-house.svg"
import { ReactComponent as CollapseExpand } from "./website-icons/collapse-expand-icon.svg"
import { ReactComponent as EnvelopInColor } from "./website-icons/envelope-in-color.svg"
import { ReactComponent as FooterHexagonButton } from "./website-icons/footer-soc-hexagon.svg"
import { ReactComponent as WebsiteSliderHexButton } from "./website-icons/hexagon-slider-button.svg"
import { ReactComponent as InfoSquare } from "./website-icons/info-square.svg"
import { ReactComponent as PdfLogo } from "./website-icons/pdf-logo.svg"
import { ReactComponent as PlaneRoute } from "./website-icons/plane-route.svg"
import { ReactComponent as HexagonProcess } from "./website-icons/processItem.svg"
import { ReactComponent as HexagonProcessBadge } from "./website-icons/processItemBedge.svg"
import { ReactComponent as ReadMoreArrowRight } from "./website-icons/read-more-arrow-right.svg"
import { ReactComponent as WebsiteSliderArrowLeft } from "./website-icons/slider-arrow-left.svg"
import { ReactComponent as WebsiteSliderArrowRight } from "./website-icons/slider-arrow-right.svg"
import { ReactComponent as UploadArrow } from "./website-icons/upload-arrow.svg"
import { ReactComponent as WrenchGear } from "./website-icons/wrench-gear.svg"

export const publicIcons: Record<string, IconComponent> = {
  "rotate-orbit": RotateOrbit,
  "map-pinned-geometry": MapPinnedGeometry,
  "orange-circles": OrangeCircles,
  "collapse-mode": CollapseMode,
  "expand-mode": ExpandMode,
  "little-cross": LittleCross,
  "users": Users,
  "whatsapp-new": WhatsAppNew,
  "emails": Emails,
  "user": User,
  "profile": Profile,
  "photo-camera": PhotoCamera,
  "aoi": Aoi,
  "copy-file": CopyFile,
  "square-links": SquareLinks,
  "upload-arrow": UploadArrow,
  "envelope-upload": EnvelopeUpload,
  "exclamation": Exclamation,
  "green-tick-in-circle": GreenTickInCircle,
  "blue-tick": BlueTick,
  "envelope-with-lock": EnvelopWithLock,
  "envelop-in-color": EnvelopInColor,
  "headphones": Headphones,
  "tick": Tick,
  "calendar-all": CalendarAll,
  "long-right-arrow": LongRightArrow,
  "kml": KmlIcon,
  "json": JsonIcon,
  "zip": Zipfile,
  "tiff": TiffIcon,
  "docx": DocxIcon,
  "pdf-doc-icon": PdfDocIcon,
  "excel-logo": ExcelLogo,
  "table": Table,
  "telegram": Telegram,
  "archive": Archive,
  "license": License,
  "circled-tick": CircledTick,
  "button-minus": ButtonMinus,
  "button-plus": ButtonPlus,
  "green-ticked": GreenTick,
  "upload-in-color": UploadColored,
  "free": Free,
  "info-circle": InfoCircle,
  "exclamation-triangle": ExclamationTriangle,
  "wrench-gear": WrenchGear,
  "plane-route": PlaneRoute,
  "cell-house": CellHouse,
  "call-center": CallCenter,
  "info-square": InfoSquare,
  "details": Details,
  "approvals": Approvals,
  "documents": Documents,
  "clock": Clock,
  "doc-file": DocFile,
  "exclamation-square": ExclamationSquare,
  "camera": Camera,
  "save": Save,
  "close": Close,
  "minimize": Minimize,
  "image": Image,
  "whatsapp": Whatsapp,
  "phone": Phone,
  "burger-icon": BurgerIcon,
  "at": At,
  "request-info": RequestInfo,
  "pdf-logo": PdfLogo,
  "expand-arrow-down": ExpandArrowDown,
  "expand-arrow-up": ExpandArrowUp,
  "slider-settings": SliderSettings,
  "eye": Eye,
  "warning-circle": WarningCircle,
  "process-item": HexagonProcess,
  "process-badge": HexagonProcessBadge,
  "footer-soc-btn": FooterHexagonButton,
  "collapse-expand": CollapseExpand,
  "project-info": ProjectInfo,
  "logo": Logo,
  "logo-dark-blue-flipped": LogoDarkBlueFlipped,
  "settings": Settings,
  "magnifying-glass": MagnifyingGlass,
  "magnifying-glass-gray": MagnifyingGlassGray,
  "down": DownArrow,
  "arrow-left": ArrowLeft,
  "arrow-right": ArrowRight,
  "arrow-scroll-up": ArrowScrollUp,
  "read-more-arrow-right": ReadMoreArrowRight,
  "arrow-back": ArrowBack,
  "calendar": Calendar,
  "close-modal": CloseModal,
  "app-create-upload": AppCreateUpload,
  "refresh": Refresh,
  "bin": Bin,
  "download": Download,
  "clip": Clip,
  "small-white-tick": SmallWhiteTick,
  "checked": Checked,
  "double-gray-dots": DoubleGrayDots,
  "envelop": Envelop,
  "close-notification": CloseNotification,
  "manager-map": ManagerMap,
  "easetech": Easetech,
  "logo-easetech-white": LogoEasetechWhite,
  "website-slider-hex-button": WebsiteSliderHexButton,
  "website-slider-arrow-left": WebsiteSliderArrowLeft,
  "website-slider-arrow-right": WebsiteSliderArrowRight,
  "client-centric": ClientCentric,
  "lamp-idea": LampIdea,
  "money-circle": MoneyCircle,
  "starred-award": StarredAward,
  "thumb-up": ThumbUp,
  "timer": Timer,
  "file-play": FilePlay,
  "emergency-alert": Emergency,
}
